// extracted by mini-css-extract-plugin
export default {"container":"o3taSv"};